__turbopack_context__.v({
  "container": "applicationFallback-module-scss-module__uH4x9a__container",
  "message": "applicationFallback-module-scss-module__uH4x9a__message",
  "messageHeader": "applicationFallback-module-scss-module__uH4x9a__messageHeader",
  "messageWrapper": "applicationFallback-module-scss-module__uH4x9a__messageWrapper",
  "reloadIcon": "applicationFallback-module-scss-module__uH4x9a__reloadIcon",
  "reloadLink": "applicationFallback-module-scss-module__uH4x9a__reloadLink",
  "reloadWrapper": "applicationFallback-module-scss-module__uH4x9a__reloadWrapper",
});
